import React, { Component } from 'react';
import { Button, message } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const yearFormat = 'YYYY';
let year = moment().format(yearFormat);

class Filter extends Component {
    handleChange = (params, key) => {
        if (key === 'begin') {
            year = moment(params.begin).format(yearFormat);
        } else {
            year = moment(params.end).format(yearFormat);
        }
        params.begin = `${year}-01`;
        params.end = `${year}-12`;
        this.props.onChange(params, key);
    }

    render() {
        const { businessList, ...rest } = this.props;
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const filters = [{
            name: '统计时间段',
            key: 'begin',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '至',
            key: 'end',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '领域leader',
            key: 'leaderUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} onChange={this.handleChange} />
        )
    }
}

class ProMonthInGroupConsumeFte extends Component {
    state = {
        data: [],
        businessList: [],
        loading: false,
        sortParams: {},
        searchParams: {
            begin: `${year}-01`,
            end: `${year}-12`,
        },
        curParams: {
            begin: `${year}-01`,
            end: `${year}-12`,
        },
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.loadData();
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryInvRandomConfirmFte,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...curParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {
                ...searchParams,
            },
        }, () => {
            this.loadData();
        });
    }

    //下载站导出
    export = () => {
        const { sortParams, curParams } = this.state;
        const params = {};
        Object.keys(curParams).forEach(key => {
            const value = curParams[key];
            if (typeof value !== 'object' || value === null) {
                params[key] = value;
            }
        });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportInvRandomConfirmFte,
            data: {
                ...sortParams,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const columns = [{
            title: 'JDE主项目号',
            dataIndex: 'mainCode',
            key: 'mainCode',
            fixed: 'left',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 160,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 100,
        }, {
            title: '项目分类',
            dataIndex: 'investigationType',
            key: 'investigationType',
            width: 100,
        }, {
            title: '领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 80,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '项目经理工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 90,
        }, {
            title: '项目经理姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 90,
        }, {
            title: '项目经理主管工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 80,
        }, {
            title: '项目经理主管姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 80,
        }, {
            title: '时间',
            dataIndex: 'yearMonth',
            key: 'yearMonth',
            width: 80,
        }, {
            title: '当月筛选数',
            dataIndex: 'filterCount',
            key: 'filterCount',
            width: 80,
        },  {
            title: '当月累计筛选数',
            dataIndex: 'filterTotalCount',
            key: 'filterTotalCount',
            width: 80,
        }, {
            title: '当月随机数',
            dataIndex: 'randomCount',
            key: 'randomCount',
            width: 80,
        },  {
            title: '当月累计随机数',
            dataIndex: 'randomTotalCount',
            key: 'randomTotalCount',
            width: 80,
        },  {
            title: '当月完成访视数',
            dataIndex: 'visitNum',
            key: 'visitNum',
            width: 80,
        },  {
            title: '当月完成标准访视数',
            dataIndex: 'standardAmount',
            key: 'standardAmount',
            width: 80,
        },  {
            title: '当月在组患者数',
            dataIndex: 'inProgressNum',
            key: 'inProgressNum',
            width: 80,
        }, {
            title: '当月项目确认FTE',
            dataIndex: 'confirmFte',
            key: 'confirmFte',
            width: 90,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams, businessList } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    businessList={businessList}
                    onChange={this.handleFilterChange}
                    buttons={[
                        exportable ?
                            <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>
                        :
                            <Button key="export" disabled={true} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <TableC
                    data={data}
                    loading={loading}
                    className="proMonthInGroupConsumeFte"
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default ProMonthInGroupConsumeFte;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/proMonthInGroupConsumeFte.js